import { lazy, Suspense } from 'react';
import { LazyAssetsFallback, type LazyAssetProps } from '@frontend/internal-assets';

const LazyPracticeworks = lazy(() => import('./svg-components/practiceworks'));

const Practiceworks = ({ assetsFallbackProps = {}, customFallback, ...rest }: LazyAssetProps) => (
  <Suspense fallback={customFallback || <LazyAssetsFallback {...assetsFallbackProps} />}>
    <LazyPracticeworks {...rest} />
  </Suspense>
);

export default Practiceworks;
